import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  mixins: [renderFormMixins],
  name: "forgot",
  data: function data() {
    var _this = this;

    return {
      nameTabs: "name1",
      enterButton: this._vm.$t('loginArea.getvcode'),
      enterButton1: this._vm.$t('loginArea.getvcode'),
      formMoblie: {
        old_password: "",
        new_password1: "",
        new_password2: ""
      },
      butDisabled: false,
      butDisabled1: false,
      rules: {
        old_password: [{
          required: true,
          message: this._vm.$t('原密码不能为空'),
          trigger: 'blur'
        }],
        new_password1: [{
          required: true,
          message: this._vm.$t('新密码不能为空'),
          trigger: 'blur'
        }, {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/,
          message: '6-20位，至少包含字母数字其中两种',
          trigger: 'change'
        }],
        new_password2: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this._vm.$t('重复新密码不能为空')));
            } else if (value !== _this.formMoblie.new_password1) {
              callback(new Error(_this._vm.$t('新密码与重复新密码不一致')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      }
    };
  },
  props: {
    $store: {},
    edit: {},
    _vm: {}
  },
  computed: {
    userInfoStore: function userInfoStore() {
      var data = this.$store.state.user.userInfo;
      return data;
    }
  },
  methods: {
    clickChange: function clickChange(evt) {
      this.nameTabs = evt;
    },
    getCode: function getCode() {
      var _this2 = this;

      var time = 120,
          vm = this;
      var mobile = this.formMoblie.mobile,
          email = this.formEmail.mobile,
          mReg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
          eReg = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/,
          mob,
          mobTetx = "",
          url,
          params;

      if (this.nameTabs == "name1") {
        mob = !mReg.test(mobile);
        mobTetx = this._vm.$t('loginArea.mobilenotice');
        url = "handleGetsms";
        params = {
          mobile: mobile,
          type: 2
        };
      } else {
        mob = !eReg.test(email);
        mobTetx = this._vm.$t('loginArea.emailIncorrect');
        url = "handleGetEmall";
        params = {
          email: email,
          type: 2
        };
      }

      vm.$refs.formMoblie.validateField('mobile', function (valide) {
        if (valide === '') {
          mob = !mReg.test(mobile);
          mobTetx = vm._vm.$t('loginArea.mobilenotice');
          url = "handleGetsms";
          params = {
            mobile: mobile,
            type: 2
          };

          var callback = function callback(res) {
            if (res.result === 0) {
              _this2.$Message.success(res.errorMsg);

              vm.butDisabled = true;
              var setinter = setInterval(function () {
                if (time > 0) {
                  time--;
                  vm.enterButton = time + vm._vm.$t('loginArea.getVodeSecondAfter');
                } else {
                  vm.enterButton = vm._vm.$t('loginArea.getvcode');
                  vm.butDisabled = false;
                  clearInterval(setinter);
                }
              }, 1000);
            } else {
              _this2.$Message.error(res.errorMsg);
            }
          };

          vm.$store.dispatch(url, params).then(function (res) {
            callback(res);
          });
        }
      });
    },

    /**
     * 邮箱获取验证码
     */
    getEmailCode: function getEmailCode() {
      var _this3 = this;

      var time = 120,
          vm = this;
      var email = this.formEmail.email,
          mobTetx = "",
          url,
          params;
      vm.$refs.formEmail.validateField('email', function (valide) {
        if (valide === '') {
          mobTetx = vm._vm.$t('loginArea.emailIncorrect');
          url = "handleGetEmall";
          params = {
            email: email,
            type: 2
          };

          var callback = function callback(res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.butDisabled1 = true;
              var setinter = setInterval(function () {
                if (time > 0) {
                  time--;
                  vm.enterButton1 = time + vm._vm.$t('loginArea.getVodeSecondAfter');
                } else {
                  vm.enterButton1 = vm._vm.$t('loginArea.getvcode');
                  vm.butDisabled1 = false;
                  clearInterval(setinter);
                }
              }, 1000);
            } else {
              _this3.$Message.error(res.errorMsg);
            }
          };

          vm.$store.dispatch(url, params).then(function (res) {
            callback(res);
          });
        }
      });
    },
    handleSubmit: function handleSubmit(name, submit) {
      var _this4 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          submit();
        } else {
          _this4.$Message.error(_this4._vm.$t('loginArea.requireFieldsNotice'));
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var vm = this;

    if (this.edit) {
      vm.formMoblie.mobile = vm.userInfoStore.mobile_phone;
      vm.formEmail.email = vm.userInfoStore.email;
    }
  }
};